const shipList = [
  // Virgin Ships
  {
    ship: "Valiant Lady",
    cruiseLine: "Virgin Voyages",
    selected: false,
    compressedImageURI500x:
      "https://widgety-assets.s3.amazonaws.com/2023/10/25/23/09/15/f8e3d65e-94a6-426c-9463-678711905b2f/Virgin Voyages Scarlet Lady Exterior 1.JPG",
    compressedImageURI1000x:
      "https://widgety-assets.s3.amazonaws.com/2023/10/25/22/57/24/96a40219-0753-46ed-9b65-1171787616b7/Virgin Voyages Scarlet Lady Exterior 1.JPG",
  },
  {
    ship: "Brilliant Lady",
    cruiseLine: "Virgin Voyages",
    selected: false,
    compressedImageURI500x:
      "https://widgety-assets.s3.amazonaws.com/2023/10/25/23/09/16/077e5faa-8527-4e62-815b-e8e6374585d8/Virgin Voyages Brilliant Lady Exterior Rendering.jpg",
    compressedImageURI1000x:
      "https://widgety-assets.s3.amazonaws.com/2023/10/25/22/57/32/34d34eae-4e57-4a4e-aaab-e7cc8148fc64/Virgin Voyages Brilliant Lady Exterior Rendering.jpg",
  },
  {
    ship: "Scarlet Lady",
    cruiseLine: "Virgin Voyages",
    selected: false,
    compressedImageURI500x:
      "https://widgety-assets.s3.amazonaws.com/2023/10/25/23/09/27/de8ac7cd-8d04-4a89-acd3-e34ad56eada1/Virgin Voyages Scarlet Lady Exterior 0.JPG",
    compressedImageURI1000x:
      "https://widgety-assets.s3.amazonaws.com/2023/10/25/22/57/41/5fc518c7-e4f2-4e8d-8c19-b2073327facf/Virgin Voyages Scarlet Lady Exterior 0.JPG",
  },
  {
    ship: "Resilient Lady",
    cruiseLine: "Virgin Voyages",
    selected: false,
    compressedImageURI500x:
      "https://widgety-assets.s3.amazonaws.com/2023/10/25/23/09/34/3b09dd5a-bf08-429d-ac69-60b124ad6e7b/Virgin Voyages Resilient Lady Sunset Render.jpg",
    compressedImageURI1000x:
      "https://widgety-assets.s3.amazonaws.com/2023/10/25/22/57/47/c4af2c80-653c-411c-8000-d7a329b35b4b/Virgin Voyages Resilient Lady Sunset Render.jpg",
  },
];

module.exports = shipList;
